<template>
  <div>
    <slot
      name="action"
      v-bind="{
        isExpanded: transition.isExpanded,
        open: transition.open,
        close: transition.close,
      }"
    />
    <transition
      name="expand"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <slot v-if="transition.isExpanded.value" />
    </transition>
  </div>
</template>

<script setup lang="ts">
  //TODO: add tests
  import { onMounted, nextTick } from 'vue';
  import { useExpandableTransition } from './model';

  const props = defineProps<{
    radio?: boolean;
    isActiveByDefault?: boolean;
  }>();

  const transition = useExpandableTransition(props.radio);

  function afterEnter(element: HTMLElement) {
    element.style.height = 'auto';
  }

  function enter(element: HTMLElement) {
    const { height } = getComputedStyle(element);

    element.style.height = '0';
    requestAnimationFrame(() => (element.style.height = height));
  }

  function leave(element: HTMLElement) {
    const { height } = getComputedStyle(element);

    element.style.height = height;
    requestAnimationFrame(() => (element.style.height = '0'));
  }

  defineExpose({
    isExpanded: transition.isExpanded,
    open: transition.open,
    close: transition.close,
  });

  onMounted(() => {
    nextTick(() => {
      if (props.isActiveByDefault) {
        transition.open();
      }
    });
  });
</script>

<style scoped>
  .expand-enter-active,
  .expand-leave-active {
    transition: height 0.3s ease-in;
    overflow: hidden;
  }

  .expand-enter,
  .expand-leave-to {
    height: 0;
  }
</style>
